export function servicesCardList() {
    const $window = $(window);
    const parent = $(".services-card-list.slider-on-mobile");

    function mobileSlider() {
        parent.each(function () {
            let $this = $(this);
            if ($window.innerWidth() >= 1200) {
                if ($this.hasClass("slick-initialized")) {
                    $this.slick('refresh');
                    $this.slick('unslick');
                }
            } else {
                if (!$this.hasClass("slick-initialized")) {
                    $this.slick({
                        dots: true,
                        arrows: false,
                        infinite: false,
                        speed: 700,
                        cssEase: 'ease',
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        mobileFirst: true,
                        responsive: [
                            {
                                breakpoint: 550,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1,
                                }
                            },
                            {
                                breakpoint: 1023,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 1,
                                }
                            },
                        ]
                    })
                }
            }
        });
    }

    $window.on("load resize", function () {
        setTimeout(() => {
            mobileSlider();
        }, 300);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/servicesCardList.js